import React, { Component, ReactNode } from 'react'
import { connect } from 'react-redux'
import { change, reset } from 'redux-form'
import { History } from 'history'

import { fetchModels } from '../vehicles/vehiclesActions'
import { selectVehicleMakeModelMeta } from '../../reducers/vehicles'
import { parseQueryForDisplay, stringifyQuery } from '../../helpers/queryHelper'
import VehicleFilterForm from './vehicleFilterForm'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  change: Callback
  fetchModels: Callback
  history: History
  location: Location
  makes: { models: string[] }
  reset: Callback
  vehicleMeta: object
}

export class VehiclesFilter extends Component<Props> {
  onSubmit = (values) => {
    const { history } = this.props
    const withDefaults = Object.assign({}, values, {
      offset: 0,
      limit: 25,
    })
    history.push({
      pathname: '/vehicles',
      search: stringifyQuery(withDefaults),
    })
  }

  renderYears = () => {
    let years: ReactNode[] = []
    const currentYear = new Date().getFullYear()
    for (let i = currentYear; i >= 1981; i--) {
      years.push(
        <option key={i} value={i}>
          {i}
        </option>
      )
    }
    return years
  }

  cancel = () => {
    const {
      history,
      location: { search },
    } = this.props
    history.push({
      pathname: '/vehicles',
      search,
    })
  }

  destroy = () => {
    const {
      change,
      history,
      reset,
      location: { search },
    } = this.props
    const valueArray = Object.keys(parseQueryForDisplay(search))
    reset('vehicleFilterForm')
    valueArray.forEach((value) => {
      change('vehicleFilterForm', value, null)
    })
    history.push({
      pathname: '/vehicles',
    })
  }

  initialValues = () => {
    const { location } = this.props
    return parseQueryForDisplay(location.search)
  }

  render() {
    const { makes, fetchModels, vehicleMeta } = this.props
    return (
      <div className="index-vehicle-filter">
        <h1 className="index-filter__header">Vehicle Filters</h1>
        <VehicleFilterForm
          onSubmit={this.onSubmit}
          initialValues={this.initialValues()}
          cancel={this.cancel}
          clear={this.destroy}
          vehicleMeta={vehicleMeta}
          vehicleMakes={makes}
          fetchModels={fetchModels}
          renderYears={this.renderYears}
        />
      </div>
    )
  }
}

export const mapStateToProps = (state) => {
  return {
    makes: state.makes,
    vehicleMeta: selectVehicleMakeModelMeta(state.vehicles),
  }
}

export default connect(mapStateToProps, {
  reset,
  change,
  fetchModels,
})(VehiclesFilter)
